import { render } from "./MarketReportsMenu.vue?vue&type=template&id=237ddda8&scoped=true"
import script from "./MarketReportsMenu.vue?vue&type=script&lang=js"
export * from "./MarketReportsMenu.vue?vue&type=script&lang=js"

import "./MarketReportsMenu.vue?vue&type=style&index=0&id=237ddda8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237ddda8"]])

export default __exports__